export const promoFreeShipping = 'freeshipping';
